import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import SOUNDS from 'sounds'

export const AVAILABLE_BUILDINGS_REQUEST = 'available_buildings/REQUEST'
export const AVAILABLE_BUILDINGS_SUCCESS = 'available_buildings/SUCCESS'
export const AVAILABLE_BUILDINGS_ERROR = 'available_buildings/ERROR'
export const AVAILABLE_BUILDINGS_SELECT = 'available_buildings/SELECT'

export function selectBuilding(selectedBuildingIdx) {
    return {
        type: AVAILABLE_BUILDINGS_SELECT,
        payload: { selectedBuildingIdx },
        meta: {
            webToClient: {
                handler: 'playSound',
                params: { soundId: SOUNDS.CAROUSEL_CLICK },
            },
        },
    }
}

export function startRequest() {
    return {
        type: AVAILABLE_BUILDINGS_REQUEST,
    }
}

export function requestSuccess(buildings) {
    return {
        type: AVAILABLE_BUILDINGS_SUCCESS,
        payload: { buildings },
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: AVAILABLE_BUILDINGS_ERROR,
        payload: errorData,
    }
}

export default function requestAvailableBuildings() {
    return (dispatch, getState) => {
        if (getState().availableBuildings.loading) {
            return Promise.resolve()
        }
        dispatch(startRequest())
        httpRequest('/game_api/available_buildings')
            .then(
                buildings => dispatch(requestSuccess(buildings)),
                errorData => dispatch(requestError(errorData))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/available_buildings.js